import {React, useCallback, useContext, useState } from 'react';
import { useNavigate } from "react-router-dom";
import "./Select.scss";
import { imageSet } from "./App";
import NextButton from './nextButton.js';
import FrameWhite from "./img/frame_01white.png";
import AppContext from './AppContext';

let selectedImageIndex = [null, null, null, null];

function ImgTable() {
  
  const [ ,test] = useState();
  const forceUpdate = useCallback(() => test({}), []);

  const myContext = useContext(AppContext);

  const handleImageClick = (index) => () => {
    const existingSlot = selectedImageIndex.indexOf(index);
    
    if (existingSlot !== -1) {
      selectedImageIndex[existingSlot] = null;
    } else {
      const emptySlot = selectedImageIndex.indexOf(null);
      if (emptySlot !== -1) {
        selectedImageIndex[emptySlot] = index;
      }
    }

    forceUpdate();
  }
  
  const navigate = useNavigate();

  const renderNumber = (n) => {
    const slotIndex = selectedImageIndex.indexOf(n);
    if(slotIndex >= 0){
      return (
        <div className="circle">
          <span>
            {slotIndex + 1}
          </span>
        </div>
      );
    }
  }

  const handleSaveClick = () => {
    const isAllSelected = selectedImageIndex.every(val => val !== null);
    
    if (isAllSelected) {
      let i = 1;
      for (var key of selectedImageIndex) {
        myContext.imageSelected4[i++] = imageSet[key];
      }
      navigate("/frame");
    } else {
      alert("사진 4장을 모두 선택해주세요!");
    }
  }

  return (
    <>
      <div className="frameImgPreview">
        <div className="previewContainer">
          <img src={FrameWhite} className="previewFrame" alt="White Frame"/>
          <div className="previewPhotos">
            <img 
              src={imageSet[selectedImageIndex[0]]} 
              className="prevPhoto" 
              alt="" 
              style={{ visibility: selectedImageIndex[0] !== null ? 'visible' : 'hidden' }}
            />
            <img 
              src={imageSet[selectedImageIndex[1]]} 
              className="prevPhoto" 
              alt="" 
              style={{ visibility: selectedImageIndex[1] !== null ? 'visible' : 'hidden' }}
            />
            <img 
              src={imageSet[selectedImageIndex[2]]} 
              className="prevPhoto" 
              alt="" 
              style={{ visibility: selectedImageIndex[2] !== null ? 'visible' : 'hidden' }}
            />
            <img 
              src={imageSet[selectedImageIndex[3]]} 
              className="prevPhoto" 
              alt="" 
              style={{ visibility: selectedImageIndex[3] !== null ? 'visible' : 'hidden' }}
            />
          </div>
        </div>
      </div>
      <div className="selectionArea">
        <table className="ImageTable">
          <tbody>
            <tr>
              <td style={{ position: 'relative' }}>
                <img src={imageSet[0]} onClick={handleImageClick(0)} className="captureImg" alt=""/>
                {renderNumber(0)}
              </td>
              <td style={{ position: 'relative' }}>
                <img src={imageSet[1]} onClick={handleImageClick(1)} className="captureImg" alt=""/>
                {renderNumber(1)}
              </td>
            </tr>
            <tr>
              <td style={{ position: 'relative' }}>
                <img src={imageSet[2]} onClick={handleImageClick(2)} className="captureImg" alt=""/>
                {renderNumber(2)}
              </td>
              <td style={{ position: 'relative' }}>
                <img src={imageSet[3]} onClick={handleImageClick(3)} className="captureImg" alt=""/>
                {renderNumber(3)}
              </td>
            </tr>
            <tr>
              <td style={{ position: 'relative' }}>
                <img src={imageSet[4]} onClick={handleImageClick(4)} className="captureImg" alt=""/>
                {renderNumber(4)}
              </td>
              <td style={{ position: 'relative' }}>
                <img src={imageSet[5]} onClick={handleImageClick(5)} className="captureImg" alt=""/>
                {renderNumber(5)}
              </td>
            </tr>
            <tr>
              <td style={{ position: 'relative' }}>
                <img src={imageSet[6]} onClick={handleImageClick(6)} className="captureImg" alt=""/>
                {renderNumber(6)}
              </td>
              <td style={{ position: 'relative' }}>
                <img src={imageSet[7]} onClick={handleImageClick(7)} className="captureImg" alt=""/>
                {renderNumber(7)}
              </td>
            </tr>
          </tbody>
        </table>
        <div className="nextButtonContainer">
          <div onClick={ handleSaveClick }><NextButton></NextButton></div>
        </div>
      </div>
    </>
  );
}

function Select() {
  const myContext = useContext(AppContext);

  return (
    <div className="bodyDiv">
      <h1 className="title">사진을 선택해주세요</h1>
      <div className="centerContainer">
        <ImgTable></ImgTable>
      </div>
    </div>
  )
}

export default Select;
